import React from 'react';
import { Typography } from '@mui/material';

const BusinessHoursDisplay = ({ business_hours,compColor=
  false
 }) => {
  // Get today's day name in lowercase
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
  
  // Check if today's data exists
  const todayHours = business_hours[today];
  
  if (!todayHours) {
    return (
      <Typography sx={{
        fontSize: { xs: "0.85rem !important", sm: "0.95rem !important", md: "1rem !important" },
        color: !compColor ? "#444444":"#fff",
        mb: { xs: 2, sm: 3 }
      }}>
        Closed today
      </Typography>
    );
  }

  if (todayHours.closed) {
    return (
      <Typography sx={{
        fontSize: { xs: "0.85rem !important", sm: "0.95rem !important", md: "1rem !important" },
        color: !compColor ? "#444444":"#fff",
        mb: { xs: 2, sm: 3 }
      }}>
        Closed today
      </Typography>
    );
  }

  // Convert 24-hour time to 12-hour format with AM/PM
  const convertTo12Hour = (time24) => {
    const [hours, minutes] = time24.split(':');
    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${period}`;
  };

  const openTime = convertTo12Hour(todayHours.open);
  const closeTime = convertTo12Hour(todayHours.close);

  return (
    <Typography sx={{
      fontSize: { xs: "0.85rem !important", sm: "0.95rem !important", md: "1rem !important" },
      color:!compColor ? "#444444":"#fff",
      mb: { xs: 2, sm: 3 }
    }}>
      Today: {openTime} to {closeTime}
    </Typography>
  );
};

export default BusinessHoursDisplay;